import { Component, OnInit } from '@angular/core';
import { JsonService } from '../_services/json.service';
import { ActivatedRoute } from '@angular/router';
import { Location } from "@angular/common";
import { FormGroup, FormControl, FormBuilder } from "@angular/forms";
import { DomSanitizer } from '@angular/platform-browser';
import {CdkAccordionModule} from '@angular/cdk/accordion';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoggerService } from '../_services/logger.service';
import { Prescription } from '../_models/prescription.model';

@Component({
  selector: 'app-historico',
  templateUrl: './historico.component.html',
  styleUrl: './historico.component.scss'
})
export class HistoricoComponent implements OnInit {
  public listaItens!: Prescription;
  public detalhe: Array<any> = [];
  public historico: Array<any> = [];
  public infoRecognized: Array<any> = [];
  public loading: boolean = true;
  public isModalOpen: boolean = false;
  public exibirHistorico: boolean = true;
  public conteudoObj: Array<any> = [];
  public uid: string = '';
  public items = ['Item 1', 'Item 2', 'Item 3', 'Item 4', 'Item 5'];
  public expandedIndex = 0;
  public contentObj: any;
  

  constructor(
    private jsonService: JsonService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private _sanitizer: DomSanitizer,
    private translate: TranslateService,
    private logger: LoggerService
  ) { }


  ngOnInit(): void {
    this.uid = this.route.snapshot.paramMap.get('uid') + '';
    if(this.uid){
      this.getJsonData(this.uid);
    }
  }

  private getJsonData(uid: string) {
    this.jsonService.getItem(uid).subscribe(
      resp => {
        this.listaItens = resp.prescription;
        this.conteudoObj = JSON.parse(this.listaItens.conteudo);
        this.historico = JSON.parse(this.listaItens.historicoConteudo);

        if(this.historico && this.historico.length > 0){
          this.historico = this.historico.concat(this.conteudoObj);
        }else{
          this.exibirHistorico = false;
        }
      },
      erro => {
        this.logger.error('Erro ao carregar dados do histórico', erro);
      }
    );
  }

  public criaLista(listaString: string): string {
    let lista = JSON.parse(listaString);
    let retunrText = '';
    
    lista.forEach(element => {
      if (lista.indexOf(element) > 0) retunrText += ', ';
      retunrText += element;
    });
    
    return retunrText;

  }
  
  public switchString(value: string): string {
    switch (value) {
      case 'status':
        return 'Status';
      case 'pais':
        return 'Country';
      case 'crm':
        return 'CRM';
      case 'endereco':
        return 'Endereco';
      case 'especialidademedico':
        return 'Especialida do(a) médico(a)';
      case 'nomemedico':
        return 'Nome do(a) médico(a)';
      case 'posologia1':
        return 'Posologia 1';
      case 'posologia2':
        return 'Posologia 2';
      case 'posologia3':
        return 'Posologia 3';
      case 'posologia4':
        return 'Posologia 4';
      case 'produto1':
        return 'Produto 1';
      case 'produto2':
        return 'Produto 2';
      case 'produto3':
        return 'Produto 3';
      case 'produto4':
        return 'Produto 4';
      case 'emailRevisor':
        return 'Revisor';
      default:
        return value;
    }
  }
}
